import { cn } from '@/lib/utils'
import { displayDate } from '@/frontend/pages/Dashboard/Workflows/presentation'
import BlockState from '@/frontend/pages/Dashboard/Workflows/BlockState'
import type { Copy, StateEnvelope, TenantStatus } from '@/frontend/pages/Dashboard/Workflows/types'

export default function WorkerStatus({ state, copy }: { state: StateEnvelope<TenantStatus> | undefined; copy: Copy }) {
  const status = state?.data
  if (!status) return <BlockState loading={!state} error={state?.error} copy={copy} />
  const tone = status.stale ? 'bg-warning' : { loaded: 'bg-success ring-4 ring-success/15', updating: 'bg-warning', failed: 'bg-destructive', stopped: 'bg-muted-foreground' }[status.state]
  return <div className="space-y-1 sm:text-right">
    <p className="flex items-center gap-2 text-sm font-medium sm:justify-end"><span className={cn('size-2 shrink-0 rounded-full', tone)} aria-hidden />{status.stale ? copy.status_stale : copy.worker_states[status.state]}</p>
    <p className="text-xs text-muted-foreground">{copy.status_verified_at} <time dateTime={status.updated_at}>{displayDate(status.updated_at, copy.shared.not_informed)}</time></p>
  </div>
}
